<template>
  <section
    class="cta-banner-section"
    :style="{ backgroundImage: 'url(/assets/background2.svg)' }"
  >
    <v-container style="max-width: 860px; position: relative; z-index: 1; text-align: center">
      <h2 class="cta-headline anim anim-1">{{ $t('ctaBanner.headline') }}</h2>
      <p class="cta-sub anim anim-2">{{ $t('ctaBanner.sub') }}</p>
      <div class="cta-row anim anim-3">
        <v-btn depressed large rounded class="btn-primary px-8" @click="dialog = true">
          {{ $t('ctaBanner.cta1') }}
        </v-btn>
        <v-btn text large class="btn-ghost" @click="dialog = true">
          {{ $t('ctaBanner.cta2') }}
          <v-icon right small>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </v-container>

    <!-- Registration Dialog -->
    <v-dialog v-model="dialog" max-width="480" persistent>
      <v-card style="border-radius: 20px; padding: 8px">
        <v-card-title class="dialog-title pt-6 px-6 mb-4">Сургуулиа бүртгүүлэх</v-card-title>
        <v-card-subtitle class="dialog-sub px-6 pb-4">Мэдээллийг бөглөж бидэнтэй холбогдоорой.</v-card-subtitle>
        <v-card-text class="px-6">
          <v-text-field
            v-model="form.school"
            label="Сургуулийн нэр"
            outlined
            dense
            rounded
            class="mb-2"
            prepend-inner-icon="mdi-school-outline"
          />
          <v-text-field
            v-model="form.phone"
            label="Утасны дугаар"
            outlined
            dense
            rounded
            class="mb-2"
            prepend-inner-icon="mdi-phone-outline"
            type="tel"
          />
          <v-text-field
            v-model="form.email"
            label="И-мэйл хаяг"
            outlined
            dense
            rounded
            prepend-inner-icon="mdi-email-outline"
            type="email"
          />
        </v-card-text>
        <v-card-actions class="px-6 pb-6" style="gap: 10px">
          <v-btn text rounded class="flex-grow-1" @click="dialog = false" style="text-transform: none; color: #888">Цуцлах</v-btn>
          <v-btn color="primary" depressed rounded class="flex-grow-1" @click="dialog = false" style="text-transform: none; font-weight: 700">Илгээх</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
export default {
  name: 'CtaBanner',
  data() {
    return {
      dialog: false,
      form: { school: '', phone: '', email: '' },
    }
  },
}
</script>

<style scoped>
.cta-banner-section {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 120px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

@keyframes fade-up {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}

.anim {
  opacity: 0;
  animation: fade-up 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
.anim-1 { animation-delay: 0.05s; }
.anim-2 { animation-delay: 0.15s; }
.anim-3 { animation-delay: 0.25s; }

.cta-headline {
  font-size: 3.6rem;
  font-weight: 900;
  color: #1a1a2e;
  letter-spacing: -2px;
  line-height: 1.1;
  margin: 0 0 20px;
}

@media (max-width: 768px) {
  .cta-headline { font-size: 2.4rem; letter-spacing: -1px; }
}

.cta-sub {
  font-size: 1.05rem;
  color: #555;
  line-height: 1.75;
  margin: 0 0 40px;
}

.cta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-primary {
  text-transform: none !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  height: 52px !important;
  background: #1a1a2e !important;
  color: white !important;
}

.btn-primary:hover {
  background: #2c2c4a !important;
}

.btn-ghost {
  text-transform: none !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  color: #1a1a2e !important;
  height: 52px !important;
}

.dialog-title {
  font-size: 1.3rem;
  font-weight: 800;
  color: #1a1a2e;
  letter-spacing: -0.3px;
}

.dialog-sub {
  font-size: 0.9rem;
  color: #888;
}
</style>
